import Logger from './Logger';

export default function LocalServiceWorkerRegister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        Logger.info('Ungregistering SW', registration);
        registration.unregister();
      })
      .catch((err) => {
        Logger.info('Could not load iZooto script', err);
      });
  }
}
